export const buildAddressAddons = (
  address: Record<string, string>,
  allowedFields: readonly string[],
): Record<string, string> =>
  Object.fromEntries(
    Object.entries(address)
      .filter(([field]) => allowedFields.includes(field))
      .map(([field, value]) => [field, value.trim()])
      // Geocoding a map point may resolve only a locality or district. Do not
      // send missing address components as empty strings: the API must receive
      // the parts that were actually identified, alongside coordinates.
      .filter(([, value]) => Boolean(value)),
  );

export const buildAgentCommissionAddons = (
  percent: string | number | null | undefined,
  amount: string | number | null | undefined,
  includeEmptyFields = false,
): Record<string, number | null> => {
  const addons: Record<string, number | null> = {};
  const addCommission = (field: string, value: string | number | null | undefined) => {
    const normalizedValue = String(value ?? "").trim();
    if (normalizedValue) {
      addons[field] = Number(normalizedValue);
    } else if (includeEmptyFields) {
      addons[field] = null;
    }
  };

  addCommission("agent_commission_percent", percent);
  addCommission("agent_commission_amount", amount);

  return addons;
};
